// extracted by mini-css-extract-plugin
export default {"wrapper__body":"accordion_wrapper__body__If4UA","wrapper__body--scroll":"accordion_wrapper__body--scroll__ETST0","wrapper__content":"accordion_wrapper__content__RXg5K"};